import { signOut as corporateGroupLogout } from 'next-auth/react';
import { LinkId } from '../../../../AnalyticsContext/LinkId';
import { IdentityProvider } from '../../../../UserProvider/UserData';
import { useUserData } from '../../../../UserProvider/UserProvider';
import { useLogout } from '../../../../UserProvider/useLogout';
import { IconHealthEngineWithText } from '../../../icons/IconHealthEngineWithText';
import { StyledLink } from '../Jumbotron/Jumbotron.styles';
import { HomeLink, HomeWrapper, LinksView, LogoutLink } from './Links.styles';

interface Props {
  onSelect?: VoidFunction;
  onClickLogout?: VoidFunction;
  showExternalActions: boolean;
}

export const Links = ({ onClickLogout, onSelect, showExternalActions }: Props) => {
  const { data: user, loading: userLoading, identityProvider } = useUserData();
  const heLogout = useLogout();

  const handleLogoutClick = () => {
    onClickLogout?.();

    if (user) {
      identityProvider === IdentityProvider.HEALTHENGINE && heLogout();
      identityProvider === IdentityProvider.CORPORATE_GROUP && corporateGroupLogout();
    }
  };

  return (
    <LinksView>
      {identityProvider === IdentityProvider.HEALTHENGINE && showExternalActions && (
        <>
          <StyledLink onClick={onSelect} to="/" trackingId={LinkId.MOBILE_MENU_FIND_A_PROVIDER}>
            Find a provider
          </StyledLink>

          <StyledLink
            onClick={onSelect}
            to="https://he.app.link/Atw5J9PBPU"
            trackingId={LinkId.MOBILE_MENU_DOWNLOAD_APP}
          >
            Download the app
          </StyledLink>

          <StyledLink onClick={onSelect} to="/info" trackingId={LinkId.MOBILE_MENU_BLOG}>
            Blog
          </StyledLink>

          {!user && !userLoading && (
            <StyledLink
              onClick={onSelect}
              to="https://practices.healthengine.com.au/list-your-practice/?pracsource=header-link"
              trackingId={LinkId.MOBILE_MENU_ARE_YOU_A_PRACTICE}
            >
              List your practice, it's free
            </StyledLink>
          )}

          <StyledLink
            data-testid="helpLink"
            onClick={onSelect}
            to="https://support.healthengine.com.au/hc/en-us/categories/200431715-Patient"
            trackingId={LinkId.MOBILE_MENU_HELP}
          >
            Help
          </StyledLink>
        </>
      )}

      {user && <LogoutLink onClick={handleLogoutClick}>Logout</LogoutLink>}

      {showExternalActions && (
        <HomeWrapper>
          <HomeLink to="/" title="Home" onClick={onSelect}>
            <IconHealthEngineWithText />
          </HomeLink>
        </HomeWrapper>
      )}
    </LinksView>
  );
};
